<template>
  <div class="layout">
    <Header></Header>
    <div class="layout-banner flex-row">
      <div class="container business-banner-title">
        <p>产业项目布局</p>
        <p>
          直通项目落地最后一公里，专业服务让企业更受益。
        </p>
      </div>
    </div>
    <div class=" service-matrix">
      <div class="container">
        <h1>以项目落地为核心，搭建3+X服务矩阵</h1>
        <div class="matrix-container flex-row">
          <div class="matrix-item flex-col wow animate__animated animate__fadeInUp" :data-wow-delay="'.'+i*2+'s'" data-wow-offset="100" v-for="(v,i) in matrixList" :key='i'>
            <img :src="v.bg" alt="">
            <div :style="`background:url(${v.bg1});`" :class="{title:true,'p-lw-10':i===2}">
              {{v.desc1}}
            </div>
            <div class="desc">{{v.desc2}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="accordion-container">
      <div class="container">
        <h1>专业、高效、精准服务</h1>
        <div class="accordion">
          <div class="panel flex-row" v-for="(v,index) in imgs" :key="index" :class="{active:index===active}" @mouseenter="active=index"
            :style="{background:active===index?`url(${v.bg1})`:`url(${v.bg2})`}">
            <div class="panel-introduce flex-row" :class="{tranform:active==index}">
              <span class="deActive" :class="{ml:active==index}">{{v.title}}</span>
              <p v-if="active===index" class="flex-row">{{v.desc}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cooperation-enterprise">
        <h1>合作企业</h1>
        <br/><br/>
        <div class="container company-list">
          <img style="position:absolute;left:0;top:0;z-index:1;height: 1000px;" src="@/assets/images/business/layout-left-shadow.png" alt="">
          <img style="position:absolute;right:-5px;top:-7px;z-index:1;height: 1000px;" src="@/assets/images/business/layout-right-shadow.png" alt="">
          <div class="company flex-row">
            <img src="@/assets/images/business/company1.png" alt="">
            <img src="@/assets/images/business/company2.png" alt="">
            <img src="@/assets/images/business/company3.png" alt="">
            <img src="@/assets/images/business/company4.png" alt="">
            <img src="@/assets/images/business/company5.png" alt="">
            <img src="@/assets/images/business/company6.png" alt="">
            <img src="@/assets/images/business/company7.png" alt="">
            <img src="@/assets/images/business/company8.png" alt="">
            <img src="@/assets/images/business/company9.png" alt="">
            <img src="@/assets/images/business/company10.png" alt="">
            
            <img src="@/assets/images/business/company1.png" alt="">
            <img src="@/assets/images/business/company2.png" alt="">
            <img src="@/assets/images/business/company3.png" alt="">
            <img src="@/assets/images/business/company4.png" alt="">
            <img src="@/assets/images/business/company5.png" alt="">
            <img src="@/assets/images/business/company6.png" alt="">
            <img src="@/assets/images/business/company7.png" alt="">
            <img src="@/assets/images/business/company8.png" alt="">
            <img src="@/assets/images/business/company9.png" alt="">
            <img src="@/assets/images/business/company10.png" alt="">

          </div>
          <div class="company2 flex-row">
            <img src="@/assets/images/business/company11.png" alt="">
            <img src="@/assets/images/business/company12.png" alt="">
            <img src="@/assets/images/business/company13.png" alt="">
            <img src="@/assets/images/business/company14.png" alt="">
            <img src="@/assets/images/business/company15.png" alt="">
            <img src="@/assets/images/business/company16.png" alt="">
            <img src="@/assets/images/business/company17.png" alt="">
            <img src="@/assets/images/business/company18.png" alt="">
            <img src="@/assets/images/business/company19.png" alt="">
            <img src="@/assets/images/business/company20.png" alt="">

            <img src="@/assets/images/business/company11.png" alt="">
            <img src="@/assets/images/business/company12.png" alt="">
            <img src="@/assets/images/business/company13.png" alt="">
            <img src="@/assets/images/business/company14.png" alt="">
            <img src="@/assets/images/business/company15.png" alt="">
            <img src="@/assets/images/business/company16.png" alt="">
            <img src="@/assets/images/business/company17.png" alt="">
            <img src="@/assets/images/business/company18.png" alt="">
            <img src="@/assets/images/business/company19.png" alt="">
            <img src="@/assets/images/business/company20.png" alt="">
          </div>
          <div class="company flex-row">
            <img src="@/assets/images/business/company21.png" alt="">
            <img src="@/assets/images/business/company22.png" alt="">
            <img src="@/assets/images/business/company23.png" alt="">
            <img src="@/assets/images/business/company24.png" alt="">
            <img src="@/assets/images/business/company25.png" alt="">
            <img src="@/assets/images/business/company26.png" alt="">
            <img src="@/assets/images/business/company27.png" alt="">
            <img src="@/assets/images/business/company28.png" alt="">
            <img src="@/assets/images/business/company29.png" alt="">
            <img src="@/assets/images/business/company30.png" alt="">
            
            <img src="@/assets/images/business/company21.png" alt="">
            <img src="@/assets/images/business/company22.png" alt="">
            <img src="@/assets/images/business/company23.png" alt="">
            <img src="@/assets/images/business/company24.png" alt="">
            <img src="@/assets/images/business/company25.png" alt="">
            <img src="@/assets/images/business/company26.png" alt="">
            <img src="@/assets/images/business/company27.png" alt="">
            <img src="@/assets/images/business/company28.png" alt="">
            <img src="@/assets/images/business/company29.png" alt="">
            <img src="@/assets/images/business/company30.png" alt="">

          </div>
          <div class="company2 flex-row">
            <img src="@/assets/images/business/company31.png" alt="">
            <img src="@/assets/images/business/company32.png" alt="">
            <img src="@/assets/images/business/company33.png" alt="">
            <img src="@/assets/images/business/company34.png" alt="">
            <img src="@/assets/images/business/company35.png" alt="">
            <img src="@/assets/images/business/company36.png" alt="">
            <img src="@/assets/images/business/company37.png" alt="">
            <img src="@/assets/images/business/company38.png" alt="">
            <img src="@/assets/images/business/company39.png" alt="">
            <img src="@/assets/images/business/company40.png" alt="">

            <img src="@/assets/images/business/company31.png" alt="">
            <img src="@/assets/images/business/company32.png" alt="">
            <img src="@/assets/images/business/company33.png" alt="">
            <img src="@/assets/images/business/company34.png" alt="">
            <img src="@/assets/images/business/company35.png" alt="">
            <img src="@/assets/images/business/company36.png" alt="">
            <img src="@/assets/images/business/company37.png" alt="">
            <img src="@/assets/images/business/company38.png" alt="">
            <img src="@/assets/images/business/company39.png" alt="">
            <img src="@/assets/images/business/company40.png" alt="">
          </div>
        </div>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/css/layout.css";
import Header from './Header'
import Footer from './Footer'
export default {
  name: "Layout",
  components: {
    Header, Footer
  },
  data () {
    return {
      matrixList: [
        {
          bg: require("@/assets/images/business/matrix-1.jpg"),
          bg1: require("@/assets/images/business/matrix-4.png"),
          desc1: "企业落地选址", desc2: "通过大数据分析和线下团队建立全国政府信息库，为企业投资选址提供更多资源，让项目落地更加精准、高效。"
        },
        {
          bg: require("@/assets/images/business/matrix-2.jpg"),
          bg1: require("@/assets/images/business/matrix-5.png"),
          desc1: "产业资本导入", desc2: "平台集聚1800多家顶级投资机构，为优质项目提供融资服务；成功投资20多家公司并推动上市。"
        },
        {
          bg: require("@/assets/images/business/matrix-3.jpg"),
          bg1: require("@/assets/images/business/matrix-6.png"),
          desc1: "高端企业家社群", desc2: "依托线下上海星动力科创空间，联合产业内高端人脉打造企业家社群，建立企业与企业、企业与政府间的合作桥梁。"
        },
      ],
      active: 0,
      imgs: [
        {
          bg1: require("@/assets/images/business/product-2.png"),
          bg2: require("@/assets/images/business/product-1.png"),
          title: "项目需求",
          desc: "通过大数据分析、团队定向开发等了解企业选址需求"
        },
        {
          bg1: require("@/assets/images/business/product-4.png"),
          bg2: require("@/assets/images/business/product-3.png"),
          title: "精准匹配",
          desc: "通过大数据分析、团队定向开发等了解企业选址需求"
        },

        {
          bg1: require("@/assets/images/business/product-6.png"),
          bg2: require("@/assets/images/business/product-5.png"),
          title: "精准对接",
          desc: "通过大数据分析、团队定向开发等了解企业选址需求"
        },

        {
          bg1: require("@/assets/images/business/product-8.png"),
          bg2: require("@/assets/images/business/product-7.png"),
          title: "推动考察",
          desc: "通过大数据分析、团队定向开发等了解企业选址需求"
        },

        {
          bg1: require("@/assets/images/business/product-10.png"),
          bg2: require("@/assets/images/business/product-9.png"),
          title: "项目落地",
          desc: "通过大数据分析、团队定向开发等了解企业选址需求"
        },
      ]
    };
  },
  created () {
  },
  methods: {
  },
  mounted () {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: true
    });
    wow.init();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout.vue